import { Route, Switch } from 'react-router-dom';
import AddCompanyPage from './AddCompanyPage';
import SearchCompanyPage from './SearchCompanyPage';

/**
 * @param {object} props
 * @param {import('react-router').match} props.match
 * @returns
 */
export default function AddSuppliersRoutes({ match }) {
  return (
    <Switch>
      <Route
        path={`${match.path}/:supplierName/search`}
        component={SearchCompanyPage}
      />
      <Route path={`${match.path}/:supplierName`} component={AddCompanyPage} />
    </Switch>
  );
}
